import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ExperienceTimeline from "./ExperienceTimeline";
import TypeWriter from "../TypeWriter";
import TabWindow from "../TabWindow";

function Education() {
  return (
    <Container fluid className="about-section" id="education">
      <TabWindow
        activeTabId="education"
        activeFileName="education.log"
        language="LOG"
        lineCount="45"
      >
        <p className="terminal-cmd section-cmd">
          <span className="terminal-dollar">$</span>
          <TypeWriter text=" cat education.log --full" speed={45} />
        </p>
        <h1 className="project-heading" style={{ textAlign: "center", marginBottom: "40px" }}>
          <TypeWriter text="My " speed={60} cursor={false} />
          <TypeWriter text="Education" speed={60} className="purple" tag="strong" />
        </h1>
        <Row className="resume" style={{ justifyContent: "center", paddingTop: "0px" }}>
          <Col md={12}>
            <ExperienceTimeline
              index={0}
              title="Dayananda Sagar College of Engineering, Bengaluru"
              role="B.E. in Artificial Intelligence and Machine Learning"
              duration="2023 – 2027"
              description={
                <>
                  Currently pursuing Bachelor of Engineering in AI & ML.
                  <br />
                  Maintaining a strong academic record with a CGPA of <strong className="purple">9.07/10.0</strong>.
                </>
              }
            />
            <ExperienceTimeline
              index={1}
              title="JS Pre-University College, Bengaluru"
              role="KSEAB Board, Class XII (PCMB)"
              duration="2021 – 2023"
              description={
                <>
                  Completed Class XII education with an outstanding score of <strong className="purple">95.67%</strong>.
                </>
              }
            />
            <ExperienceTimeline
              index={2}
              title="Pine Woods English School, Bengaluru"
              role="Secondary Education (SSLC)"
              duration="2015 – 2021"
              description={
                <>
                  Completed secondary education with a distinction score of <strong className="purple">97%</strong>.
                </>
              }
            />
          </Col>
        </Row>
      </TabWindow>
    </Container>
  );
}

export default Education;
